import React from 'react'

import WelcomeComponent from '../components/WelcomeComponent';

import ServicesComponent from '../components/ServicesComponent';
import "react-multi-carousel/lib/styles.css";

import ProcessComponent from '../components/ProcessComponent';
import BookingComponent from '../components/BookingComponent';
import Viator from '../components/Viator';


export default function Home() {
  return (
    <div>
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          

              <img
                src="/assets/img/outpost_gentlemen_rugged_white_adjusted.svg"
                alt="Outpost Gentlemen Logo"
                className="me-3"
                style={{ height: "300px", width: "auto" }}
              />
              <h1 className="display-4 text-white mb-3 animated slideInDown">
                   An Outpost for the Modern Traveler.
              </h1>
              {/* <div className="position-relative w-75 mx-auto animated slideInDown">
                <input
                  className="form-control border-0 rounded-pill w-100 py-3 ps-4 pe-5"
                  type="text"
                  placeholder="Eg: Thailand"
                />
                <button
                  type="button"
                  className="btn btn-primary rounded-pill py-2 px-4 position-absolute top-0 end-0 me-2"
                  style={{ marginTop: 7 }}
                >
                  Search
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      {/* About Start */}
      <WelcomeComponent />
      {/* About End */}

      {/* Service Start */}
      <ServicesComponent />
      {/* <BandsCarosel /> */}
      {/* Service End */}{/*
    

      {/* Process Start */}
      <ProcessComponent />
      {/* Process End */}


      {/* Testimonial Start */}
      {/* <TestimonialComponents /> */}
      {/* Testimonial End */}

      <Viator/>
      {/* Booking Start */}
      <BookingComponent />


      {/* Booking Start */}
    </div>
  )
}
